module.exports = __webpack_public_path__ + "img/utility.d5a38f53.png";